<div class="imei-info-container">
  <div modal-close>
    <div style="display: flex;width: 100%;position: relative;justify-content: flex-end;">
    <button mat-icon-button onfocus="blur()" class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose (click)="handleCloseSideNav()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>

<div class="container content-container" *ngIf="isSmartphone" style="max-width:750px;">
  <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-size:28px;font-weight:600;">
    <adp-label labelKey="IMEI_Info_Phones_Title"></adp-label>
  </div>
  <div *ngIf="isChatAvailable">
    <ng-container *ngTemplateOutlet="imeiInfoChatBanner"></ng-container>
  </div>
  <div>
    <mat-tab-group>
      <mat-tab [label]="tabTitleiPhone">
        <ng-container *ngTemplateOutlet="iPhoneImeiInfo"></ng-container>
      </mat-tab>
      <mat-tab [label]="tabTitleAndroid">
        <ng-container *ngTemplateOutlet="AndroidImeiInfo"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="container content-container" *ngIf="isSmartwatch" style="max-width:750px;">
  <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-size:28px;font-weight:600;">
    <adp-label labelKey="IMEI_Info_Watches_Title"></adp-label>
  </div>
  <div *ngIf="isChatAvailable">
    <ng-container *ngTemplateOutlet="imeiInfoChatBanner"></ng-container>
  </div>
  <div>
    <mat-tab-group>
      <mat-tab [label]="tabTitleApple">
        <ng-container *ngTemplateOutlet="AppleImeiInfo"></ng-container>
      </mat-tab>
      <mat-tab [label]="tabTitleSamsung">
        <ng-container *ngTemplateOutlet="SamsungImeiInfo"></ng-container>
      </mat-tab>
     <mat-tab [label]="tabTitleGoogle">
        <ng-container *ngTemplateOutlet="GoogleImeiInfo"></ng-container>
      </mat-tab>
      <mat-tab [label]="tabTitleGarmin">
        <ng-container *ngTemplateOutlet="GarminImeiInfo"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="container content-container" *ngIf="isTablet" style="max-width:750px;">
  <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-size:28px;font-weight:600;">
    <adp-label labelKey="IMEI_Info_Tablets_Title"></adp-label>
  </div>
  <div *ngIf="isChatAvailable">
    <ng-container *ngTemplateOutlet="imeiInfoChatBanner"></ng-container>
  </div>
  <div>
    <mat-tab-group>
      <mat-tab [label]="tabTitleiPad">
        <ng-container *ngTemplateOutlet="iPadImeiInfo"></ng-container>
      </mat-tab>
      <mat-tab [label]="tabTitleAndroidTablet">
        <ng-container *ngTemplateOutlet="AndroidTabletImeiInfo"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #AppleImeiInfo>

  <div style="text-align: left;">
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"><adp-label labelKey="IMEI_Info_Watches_Apple_Subtitle"></adp-label></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Watches_Apple_Guide1_Title"></adp-label>
    </div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Apple_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="watchAppleGuide1ImageUrl" [alt]="watchAppleGuide1Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Watches_Apple_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Apple_Guide2_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="watchAppleGuide2ImageUrl" [alt]="watchAppleGuide2Alt"></div>
    </div>
  </div>
</ng-template>

<ng-template #SamsungImeiInfo>

  <div style="text-align: left;">
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Watches_Samsung_Guide1_Title"></adp-label>
    </div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Samsung_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="watchSamsungGuide1ImageUrl" [alt]="watchSamsungGuide1Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Watches_Samsung_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Samsung_Guide2_Description"></adp-label>
        </ul>
      </div>
    </div>
    <mat-divider style="margin-top:15px;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"><adp-label labelKey="IMEI_Info_Watches_Samsung_Alternative"></adp-label></div>
    </div>
  </div>
</ng-template>

<ng-template #GoogleImeiInfo>

  <div style="text-align: left;">
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"><adp-label labelKey="IMEI_Info_Watches_Google_Subtitle"></adp-label></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Watches_Google_Guide1_Title"></adp-label>
    </div>
    <div>
      <div style="margin-right:40px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Google_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container" style="display: flex;justify-content: center;">
        <div class="google-pixel-img-container">
        <div id="googlePixelImgDesktop"><img [src]="watchGoogleGuide1ImageUrl" [alt]="watchGoogleGuide1Alt"></div>
        <div id="googlePixelImgMobile"><img [src]="watchGoogleGuide1ImageUrlMobile" [alt]="watchGoogleGuide1AltMobile"></div>
        </div>
      </div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Watches_Google_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Google_Guide2_Description"></adp-label>
        </ul>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #GarminImeiInfo>

  <div style="text-align: left;">
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"><adp-label labelKey="IMEI_Info_Watches_Garmin_Subtitle"></adp-label></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Watches_Garmin_Guide1_Title"></adp-label>
    </div>
    <div class="heading-container">
      <div style="margin-right:40px">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Garmin_Guide1_Description"></adp-label>
        </ul>
      </div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Watches_Garmin_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Watches_Garmin_Guide2_Description"></adp-label>
        </ul>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #AndroidTabletImeiInfo>

  <div style="text-align: left;max-width:650px;">
    <div>
      <div style="margin-top:20px;"><adp-label labelKey="IMEI_Info_Tablets_Android_Subtitle"></adp-label></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Tablets_Android_Guide1_Title"></adp-label>
    </div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Tablets_Android_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="tabletAndroidTabletGuide1ImageUrl" [alt]="tabletAndroidTabletGuide1Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Tablets_Android_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Tablets_Android_Guide2_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="tabletAndroidTabletGuide2ImageUrl" [alt]="tabletAndroidTabletGuide2Alt"></div>
    </div>
  </div>

</ng-template>

<ng-template #iPadImeiInfo>

  <div style="text-align: left;max-width:650px;">
    <div>
      <div style="margin-top:20px;"><adp-label labelKey="IMEI_Info_Tablets_iPad_Subtitle"></adp-label></div>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Tablets_iPad_Guide1_Title"></adp-label>
    </div>
    <div>
      <div style="margin-right:40px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Tablets_iPad_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container" style="display: flex;justify-content: center;"><img [src]="tabletiPadGuide1ImageUrl" [alt]="tabletiPadGuide1Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Tablets_iPad_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Tablets_iPad_Guide2_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="tabletiPadGuide2ImageUrl" [alt]="tabletiPadGuide2Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Tablets_iPad_Guide3_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Tablets_iPad_Guide3_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="tabletiPadGuide3ImageUrl" [alt]="tabletiPadGuide3Alt"></div>
    </div>
  </div>

</ng-template>

<ng-template #iPhoneImeiInfo>

  <div style="text-align: left;">
  <div>
    <div style="margin-top:20px;"><adp-label labelKey="IMEI_Info_Phones_iPhone_Subtitle"></adp-label></div>
  </div>
  <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
    <adp-label labelKey="IMEI_Info_Phones_iPhone_Guide1_Title"></adp-label>
  </div>
  <div class="heading-container">
    <div style="margin-right:40px;max-width:350px;">
      <ul>
        <adp-label labelKey="IMEI_Info_Phones_iPhone_Guide1_Description"></adp-label>
      </ul>
    </div>
    <div class="mobile-image-container"><img [src]="phoneiPhoneGuide1ImageUrl" [alt]="phoneiPhoneGuide1Alt"></div>
  </div>
  <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
  <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Phones_iPhone_Guide2_Title"></adp-label></div>
  <div class="heading-container">
    <div style="margin-right:40px;max-width:350px;">
      <ul>
        <adp-label labelKey="IMEI_Info_Phones_iPhone_Guide2_Description"></adp-label>
      </ul>
    </div>
    <div class="mobile-image-container"><img [src]="phoneiPhoneGuide2ImageUrl" [alt]="phoneiPhoneGuide2Alt"></div>
  </div>
</div>
</ng-template>

<ng-template #AndroidImeiInfo>
  <div style="text-align: left;">
    <div>
      <div style="margin-top:20px;margin-bottom:20px;"><adp-label labelKey="IMEI_Info_Phones_Android_Subtitle"></adp-label></div>
    </div>
    <div class="banner-container">
      <mat-icon style="color:#3C4D6A;height:26px;width:26px;overflow:visible !important;"><ng-container *ngTemplateOutlet="infoIcon"></ng-container></mat-icon>
      <adp-label labelKey="IMEI_Info_Phones_Android_Disclaimer"></adp-label>
    </div>
    <div style="margin-top:20px;margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;">
      <adp-label labelKey="IMEI_Info_Phones_Android_Guide1_Title"></adp-label>
    </div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Phones_Android_Guide1_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="phoneAndroidGuide1ImageUrl" [alt]="phoneAndroidGuide1Alt"></div>
    </div>
    <mat-divider style="margin-top:15px;;margin-bottom:15px;border-top: 1px solid #d6d6d6;"></mat-divider>
    <div style="margin-bottom:20px;color:#13223C;font-weight:600;font-size:18px;"><adp-label labelKey="IMEI_Info_Phones_Android_Guide2_Title"></adp-label></div>
    <div class="heading-container">
      <div style="margin-right:40px;max-width:350px;">
        <ul>
          <adp-label labelKey="IMEI_Info_Phones_Android_Guide2_Description"></adp-label>
        </ul>
      </div>
      <div class="mobile-image-container"><img [src]="phoneAndroidGuide2ImageUrl" [alt]="phoneAndroidGuide2Alt"></div>
    </div>
  </div>
</ng-template>

<ng-template #imeiInfoChatBanner>
  <div class="banner-container" style="text-align:left;margin-bottom:10px;">
    <div style="display:flex;">
    <div><mat-icon style="display:flex;color:#3C4D6A;height:26px;width:26px;overflow:visible !important;"><ng-container *ngTemplateOutlet="infoIcon"></ng-container></mat-icon></div>
    <div style="text-align:left;margin-left:10px;">
      <adp-label *ngIf="!isDiagnosticInviteFlow" labelKey="IMEI_Info_Disclaimer1"></adp-label>
      <button *ngIf="!isDiagnosticInviteFlow" class="link" (click)="handleChatSupport();"><adp-label labelKey="IMEI_Info_Disclaimer_Link_Text"></adp-label></button>
      <adp-label *ngIf="!isDiagnosticInviteFlow" labelKey="IMEI_Info_Disclaimer2"></adp-label>
      <adp-label *ngIf="isDiagnosticInviteFlow" labelKey="IMEI_Info_Disclaimer_Diagnostic_Invite"></adp-label>
    </div>
    </div>
  </div>
</ng-template>

</div>

    <ng-template #infoIcon>

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2585_54571)">
    <path d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z" fill="#3C4D6A"/>
    <path d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z" fill="#3C4D6A"/>
    <path d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" fill="#3C4D6A"/>
    </g>
    <defs>
    <clipPath id="clip0_2585_54571">
    <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
    </clipPath>
    </defs>
    </svg>

    </ng-template>
